import { PriceTagPresenter } from "../../organisms/pricetag/price-tag";
import { MainTemplate } from "../../template/main-template/main-template";

export const PriceTagPage = () => (
  <MainTemplate>
    <PriceTagPresenter />
  </MainTemplate>
);
